import { Button, Heading } from "@chakra-ui/react";
import React from "react";
import resume from "../Images/Sachin_Kesarwani_Resume.pdf";

import { BiArrowToBottom } from "react-icons/bi";
import { redirect } from "../utils";
const Resume = () => {

  return (
    <>
      <div style={{ width: "100%", padding: "30px", backgroundColor: "black" }}>
        <Heading color="white">Resume</Heading>
        <Button
          bg="black"
          boxShadow="0 0 3px 3px rgba(0, 255, 0, 0.5)"
          _hover={{ bg: "#2e9b56", color: "white" }}
          color="#2e9b56"
          border={"2px solid #2e9b56"}
          style={{ position: "static", marginTop: "20px" }}
          onClick={redirect}
          id="resume-button-1"
        >
          <a href={resume} id="resume-link-1" download="Sachin-Kesarwani.pdf">
            Resume
          </a>{" "}
          <BiArrowToBottom fontSize={"20px"} color={"green.600"} />
        </Button>
      </div>
    </>
  );
};

export default Resume;
